import gql from 'graphql-tag'

const archiveProduct = gql`
  mutation archiveProduct($is_archive: Boolean!, $id: Float!, $workspace_id: Float!) {
    archiveProduct(is_archive: $is_archive, id: $id, workspace_id: $workspace_id) {
      status
      msg
      data
    }
  }
`
export default archiveProduct
